import { StyleSheet } from 'aphrodite';
import { THEME } from '../../../web/components-v2/Theme/theme';

export const styles = StyleSheet.create({
	card: {
		backgroundColor: THEME.colors.background.light,
		borderRadius: THEME.common.borderRadius,
		border: `1px solid ${THEME.colors.border.light}`,
		padding: 20,
		display: 'flex',
		flexDirection: 'column',
		gap: THEME.spacing.md,
		transition: 'box-shadow 0.2s ease',
		':hover': {
			boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
		},
		[THEME.queries.md]: {
			padding: THEME.spacing.md,
		},
	},
	cardCompact: {
		backgroundColor: THEME.colors.background.light,
		borderRadius: 6,
		border: `1px solid ${THEME.colors.border.light}`,
		padding: THEME.spacing.sm,
		display: 'flex',
		flexDirection: 'column',
		gap: 6,
		transition: 'all 0.2s ease',
		':hover': {
			boxShadow: '0 2px 6px rgba(0, 0, 0, 0.08)',
			borderColor: THEME.colors.border.main,
		},
	},
	eventImageContainer: {
		position: 'relative',
		overflow: 'hidden',
		borderRadius: `${THEME.common.borderRadius}px ${THEME.common.borderRadius}px 0 0`,
		margin: '-20px -20px 0 -20px',
		[THEME.queries.md]: {
			margin: `-${THEME.spacing.md}px -${THEME.spacing.md}px 0 -${THEME.spacing.md}px`,
		},
	},
	eventImage: {
		width: 'calc(100% + 40px)',
		height: 200,
		objectFit: 'cover' as const,
		[THEME.queries.md]: {
			height: 160,
			width: `calc(100% + ${THEME.spacing.md * 2}px)`,
		},
	},
	cardContent: {
		flex: 1,
		display: 'flex',
		flexDirection: 'column',
		gap: THEME.spacing.sm,
	},
	cardContentCompact: {
		flex: 1,
		display: 'flex',
		flexDirection: 'column',
		gap: THEME.spacing.xs,
	},
	eventNameRow: {
		display: 'flex',
		alignItems: 'flex-start',
		gap: THEME.spacing.sm,
		flexWrap: 'wrap',
	},
	eventName: {
		fontSize: THEME.typography.fontSizes.lg,
		fontWeight: THEME.typography.fontWeights.bold,
		color: THEME.colors.text.main,
		margin: 0,
		overflow: 'hidden',
		textOverflow: 'ellipsis',
		display: '-webkit-box' as any,
		WebkitLineClamp: 2,
		WebkitBoxOrient: 'vertical' as any,
		flex: 1,
		minWidth: 0,
	},
	eventNameCompact: {
		fontSize: THEME.typography.fontSizes.xs,
		fontWeight: THEME.typography.fontWeights.bold,
		color: THEME.colors.text.main,
		margin: 0,
		overflow: 'hidden',
		textOverflow: 'ellipsis',
		display: '-webkit-box' as any,
		WebkitLineClamp: 2,
		WebkitBoxOrient: 'vertical' as any,
		flex: 1,
		minWidth: 0,
		lineHeight: 1.3,
	},
	dateTime: {
		fontSize: THEME.typography.fontSizes.sm,
		color: THEME.colors.text.light,
		margin: 0,
	},
	dateTimeCompact: {
		fontSize: 10,
		color: THEME.colors.text.light,
		margin: 0,
		lineHeight: 1.2,
	},
	location: {
		fontSize: THEME.typography.fontSizes.sm,
		color: THEME.colors.text.light,
		margin: 0,
		overflow: 'hidden',
		textOverflow: 'ellipsis',
		whiteSpace: 'nowrap',
	},
	details: {
		fontSize: THEME.typography.fontSizes.sm,
		color: THEME.colors.text.light,
		margin: 0,
		overflow: 'hidden',
		textOverflow: 'ellipsis',
		display: '-webkit-box' as any,
		WebkitLineClamp: 3,
		WebkitBoxOrient: 'vertical' as any,
	},
});
